import { Component, OnInit, Inject, ViewChild, OnDestroy } from '@angular/core';
import { NgForm, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute, RouterEvent, NavigationEnd } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalService } from './../services/global.service';
import { HttpService } from './../services/http.service';
import { TagMasterService } from './../services/tagmaster-service';
import { PiHistoryService } from './../services/pihistory-service';
import { TagMaster } from './../models/tagmaster.model';
import { FilterTags } from './../models/filterTag.model';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { AlertComponent } from '../common/alert/alert.component';
import { ConfirmModelComponent } from '../common/confirm-model/confirm-model.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Globals } from '../models/globals.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-tagmaster',
  templateUrl: './tagmaster.component.html',
  styleUrls: ['./tagmaster.component.css']
})
export class TagmasterComponent implements OnInit, OnDestroy {
  [x: string]: any;
  tagList: MatTableDataSource<TagMaster>;
  dataForFilter = new FilterTags();
  tags;
  fTags;
  noData;
  startAct: boolean = true;
  locationList;
  locCode;
  unitCode;
  unitList;
  useCaseList;
  useCaseForFilter;
  tagIdsToExport = [];
  filterErrMsg: boolean = false;
  isLoader: boolean = false;
  @ViewChild('filterTagForm', { static: true }) public filterTagForm: NgForm;
  @ViewChild('tagsPaginator', { static: true }) tagsPaginator: MatPaginator;
  @ViewChild('tagsTableSort', { static: true }) public tagsTableSort: MatSort;
  firstTableClass: string = "hideData";
  tagIdFilter = new UntypedFormControl('');
  
  tagDescFilter = new UntypedFormControl('');
  locationNameFilter = new UntypedFormControl('');
  displayedColumns = ['export', 'tagId', 'locationName','tenantName',  'tagDesc', 'Action'];
  disabledFlag: boolean = true;
  public destroyed = new Subject<any>();

  filterValues = {
    tagId: '',
    locationName: '',
    tagDesc: '',
  };

  constructor(
    public globals: Globals,
    public globalService: GlobalService,
    public httpService: HttpService,
    public tagMasterService: TagMasterService,
    public piHistoryService: PiHistoryService,
    public dialog: MatDialog,
    public router: Router,
    public _router: ActivatedRoute,
    public domSanitizer: DomSanitizer
  ) {
    const emptyList: any[] = [];
    this.tagList = new MatTableDataSource(emptyList);
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      takeUntil(this.destroyed)
    ).subscribe(() => {
      this.tagMasterService.getToken().subscribe(locData => {
        this.initialize();
      });

    });

    this.safeLocation = domSanitizer.bypassSecurityTrustResourceUrl(`locFocusOut(location)`)
  }

  ngOnInit() {
    // for now no data to initialized in oninit
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  initialize() {
    this.getLocationList();
   
    this.getTagList();
    this.getUseCaseList();
    if (this.tagMasterService.locationForFilter != undefined) {
      this.setFilter();
    }

    this.tagIdFilter.valueChanges.subscribe(tagId => {
      this.filterValues.tagId = tagId;
      this.tagList.filter = JSON.stringify(this.filterValues);
    });

    this.tagDescFilter.valueChanges.subscribe(tagDesc => {
      this.filterValues.tagDesc = tagDesc;
      this.tagList.filter = JSON.stringify(this.filterValues);
    });

    this.locationNameFilter.valueChanges.subscribe(locationName => {
      this.filterValues.locationName = locationName;
      this.tagList.filter = JSON.stringify(this.filterValues);
    });

  }

  setFilter() {
    this.disabledFlag = false;
    this.dataForFilter.location = this.tagMasterService.locationForFilter;
    this.dataForFilter.useCase = this.tagMasterService.ucForFilter;
    this.dataForFilter.tagId = this.tagMasterService.tagIdForFilter;

    this.useCaseList = this.tagMasterService.useCaseList;
  }

  resetFilter() {
    this.filterTagForm.reset();
    this.dataForFilter = new FilterTags();
    this.tagList = null;
    this.startAct = true;
    this.initialize();
  }
  EnabledFilter(selectedLoc) {
    this.locCode = selectedLoc.item.locationId;
    if (this.locCode == "") {
      this.filterErrMsg = true;
      this.disabledFlag = true;
    } else {
      this.filterErrMsg = false;
      this.disabledFlag = false;
    }
  }
  getUseCaseList() {
    this.isLoader = true;
    this.tagMasterService.getUseCases().subscribe(useCaseData => {
      this.useCaseList = useCaseData;
      this.isLoader = false;
    });
    this.tagMasterService.useCaseList = this.useCaseList;
  }

  moveTagAcrossPlatform() {
    let dataToPass = {
      title: this.globalService.tagMovMsg,
      isDelete: false,
      message: 'The selected Tags will ' + this.globalService.tagMovMsg + '.'
    };
    this.globalService.openModelWindow(this.moveTagsOnConfirm, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
  }

  moveTagsOnConfirm(thisRef: TagmasterComponent) {
    let values = {
      "Parameters": {
        "tagIds": thisRef.tagIdsToExport,
        "userName": thisRef.globalService.loggedInUser
      }
    }
    thisRef.tagMasterService.tagsMovement(values).subscribe((result: any): void => {
      if (String(result.value).startsWith("Success")) {
        thisRef.globalService.showAlert(AlertComponent, { success: true, message: "Tags movement request has been initiated. Please verify in target instance after sometime." });
      } else {
        thisRef.error = true;
      }
    });
  }

  isChecked(id) {
    if (this.tagIdsToExport.includes(id)) {
      return true;
    } else {
      return false;
    }
  }

  chkTagIds(event) {
    if (!this.tagIdsToExport.includes(event)) {
      this.tagIdsToExport.push(event);
    } else {
      let position = this.tagIdsToExport.indexOf(event);
      this.tagIdsToExport.splice(position, 1);
    }
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      let tagDesc = (data.tagDesc != null) ? data.tagDesc.toLowerCase() : "";
      return data.tagId.toLowerCase().indexOf(searchTerms.tagId.toLowerCase()) !== -1
       
        && tagDesc.indexOf(searchTerms.tagDesc.toLowerCase()) !== -1
        && data.locationName.toLowerCase().indexOf(searchTerms.locationName.toLowerCase()) !== -1
       
    }
    return filterFunction;
  }

  getTagList() {
    this.tagMasterService.filteredTagList(this.locCode,  this.useCaseForFilter, this.dataForFilter.tagId).subscribe((tagList: any): void => {
      this.tags = tagList;
      this.fTags = tagList;
    });
  }
  getLocationList() {
    this.isLoader = true;
    this.tagMasterService.getLocations().subscribe(locData => {
      this.locationList = locData;
      this.isLoader = false;
    }, (error) => {
      console.log(error);
    });
  }

  locFocusOut(loc) {

    let isLocation = this.locationList.filter(function (obj) {
      return obj.locationName == loc.value;
    });
    if (isLocation.length == 0) {
      this.filterErrMsg = true;
      this.disabledFlag = true;
      this.locCode = "";
    } else {
      this.locCode = isLocation[0].locationId;
      this.filterErrMsg = false;
      this.disabledFlag = false;
    }
    this.getTagList();
    /**After switching between the tabs*/
    this.tagMasterService.locationForFilter = loc.value;
  }
  
  tagIdFocusOut(tag) {
    if (tag.value != undefined) {
      this.tagMasterService.tagIdForFilter = tag.value;
    } else {
      this.tagMasterService.tagIdForFilter = "";
    }

  }
  validateUseCase(event) {
    let uc = this.useCaseList.filter(function (ucObj) {
      if (ucObj.useCaseName == event.value) {
        return ucObj.useCaseId;
      }
    });
    if (uc.length == 1) {
      this.useCaseForFilter = uc[0].useCaseId;
    }

    this.getUseCaseList();
  }

  checkUseCase(useCase) {
    if (useCase.value != '') {
      let uc = this.useCaseList.filter(function (ucObj) {
        if (ucObj.useCaseName == useCase.value) {
          return ucObj.useCaseId;
        }
      });
      if (uc.length == 1) {
        this.useCaseForFilter = uc[0].useCaseId;
      }

    } else {
      this.useCaseForFilter = "";
    }
    this.getUseCaseList();
    this.tagMasterService.ucForFilter = useCase.value;
  }

  filterTags(filterTagForm: NgForm) {
    this.isLoader = true;
    let loc = this.reverseLoc(filterTagForm.value.location);
   
    this.tagMasterService.filteredTagList(loc,  this.useCaseForFilter, this.dataForFilter.tagId).subscribe((filteredTagList: any): void => {
      this.tagList = new MatTableDataSource(filteredTagList);
      this.tagList.filterPredicate = this.createFilter();
      this.dataCheck = this.tagList.connect().pipe(map(data => data.length === 0));
      this.noData = this.arrayIsEmpty(this.dataCheck.destination.value);
      this.startAct = false;
      this.tagList.sort = this.tagsTableSort;
      this.tagList.paginator = this.tagsPaginator;
      this.firstTableClass = "showData";
      this.isLoader = false;
    });
  }

  //To check if a tagList array is empty
  arrayIsEmpty(array) {
    if (!Array.isArray(array)) {
      return false;
    }
    if (array.length == 0) {
      return true;
    }
    return false;
  }

  updateDilog(rowdata, action): void {
    rowdata.action = action;
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '80%',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: rowdata,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "Success") {
        this.globalService.showAlert(AlertComponent, { success: true, message: "Updated Successfully" });
      }
      this.getLocationList();
      if(action === 'update') {
        this.filterTags(this.filterTagForm);
      }
      
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '80%',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: {}

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "Success") {
        this.globalService.showAlert(AlertComponent, { success: true, message: "Updated Successfully" });
        

      }
      this.getLocationList();
 
    });
  }

  getLocationName(locationForTagName) {
    if (locationForTagName != null) {
      let loc = this.locationList.filter(function (locObj) {
        if (locObj.locationId == locationForTagName) {
          return locObj.locationName;
        }
      });
      return loc[0].locationName;
    }

  }

  reverseLoc(locName) {
    if (locName != '') {
      let loc = this.locationList.filter(function (locObj) {
        if (locObj.locationName == locName) {
          return locObj.locationId;
        }
      });
      return loc[0].locationId;
    } else {
      return '';
    }
  }

  
}


@Component({
  selector: 'modal-component',
  templateUrl: './modal.component.html',
  styleUrls: ['./tagmaster.component.css']
})

export class ModalComponent {
  show: boolean;
  View: boolean = false;
  editDisabled: boolean = false;
  Heading: string = "Create Tag";
  isLoader: boolean = false;
  disabledFlag: boolean = true;
  UseCaseToTags = [];
  locationList;
  useCaseList;
  availableTags;
  dropdownSettings = {};
  tempLoc: string = "-_";
  tempTagId = "-";
  locId; eqId;  disabledLoc;  disabledTT;
  locationFlag: boolean = false; 
  isEdit: boolean = false;
  errMsg: string;
  errFlag: boolean = false;
  tagAvailable: boolean = false;
  tagExistInPiPointFlag: boolean = false;
  @ViewChild('tagForm', { static: true }) public tagForm: NgForm;
  initialValue = {
    tagDesc: this.data.tagDesc,
    tagId: this.data.tagId
  };
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TagMaster,
    public httpService: HttpService,
    public globalService: GlobalService,
    public tagMasterService: TagMasterService,
    public router: Router,
    public _router: ActivatedRoute,
    public piHistoryService: PiHistoryService
  ) { };

  ngOnInit() {
    
    this.getUseCaseList();
    this.getLocationList();
    this.getAvailableTags();
    this.checkProperty();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'useCaseId',
      textField: 'useCaseName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      limitSelection: 10,
      allowSearchFilter: true
    };
  }

  checkProperty() {
    if (this.data.action == "View") {
      this.fetchUseCaseToTags();
      this.Heading = "Tag Details";
      this.isEdit = false;
      this.editDisabled = true;
    }
    if (this.data.action == "update") {
      this.fetchUseCaseToTags();
      this.Heading = "Update Tag";
      this.isEdit = true;
      this.editDisabled = true;
    }
    if (this.data.action == "Create" || this.data.action == undefined) {
      this.isLoader = false;
      

      this.Heading = "Create Tag";
      this.isEdit = false;
      this.editDisabled = false;
    }
  }


  getAvailableTags() {

    this.tagMasterService.filteredTagList('', '', '').subscribe((tagList: any): void => {
     this.availableTags = tagList;
     console.dir(this.availableTags);
    });
  }

  fetchUseCaseToTags() {
    this.tagMasterService.getUseCaseByMasterTagId(this.data.id).subscribe(tagDetail => {
      this.data.UseCaseToTags = tagDetail;
    });
  }

  getLocationList() {
    this.tagMasterService.getLocations().subscribe(locData => {
      this.locationList = locData;
      let loc = this.data.locationName;
      if (this.data.locationId == undefined && loc != undefined) {
        let location = this.locationList.filter(function (locObj) {
          return locObj.locationName == loc;
        })[0];
        this.locId = location.locationId;
        this.data.locationId = location.locationId;
      }
      else {
        this.locId = this.data.locationId;
      }

      if (this.data.action == "View" || this.data.action == "update") {
        this.disabledLoc = this.data.locationName;
      }
   
    });
  }

 
  

  getUseCaseList() {
    this.tagMasterService.getUseCases().subscribe(useCaseData => {
      this.useCaseList = useCaseData;
    });
    this.isLoader = false;
  }

  
  /** Start - Tpeahead on selet events*/
  locationChange(locationForTagName) {
    
    if (locationForTagName.item.locationName != "" || locationForTagName.item.locationName != "undefined") {
      this.locationFlag = false;
      this.tempLoc = locationForTagName.item.locationName + "_";
      this.locId = locationForTagName.item.locationId;
     
    } else {
      this.tempLoc = "_-_ ";
    }
  }

/** Start - Check for wrong input */
  locationKeyUp(selection) {
    let isLocationAvailable = this.locationList.filter(function (obj) {
      return obj.locationName == selection.value;
    });
    if (isLocationAvailable != undefined && isLocationAvailable.length == 0) {
      this.locationFlag = true;
    }
  }

  /** End - Check for wrong input */

  onDiscardClick(): void {
    this.dialogRef.close();
  }

  onCancelClick(): void {
    if(this.data.action == 'View'){
      this.tagForm.reset({
        disTagDesc: this.data.tagDesc,
        tagId: this.data.tagId
      });
    } else if(this.data.action == 'update'){
      this.tagForm.reset({
        tagDesc: this.initialValue.tagDesc,
        tagId: this.initialValue.tagId
      });
    }
       
    this.dialogRef.close("Cancel");
  }

  createSelectedUseCaseList(selectedUseCases) {
    if (selectedUseCases != undefined) {
      const newArray = selectedUseCases.map(o => {
        return { useCaseId: o.useCaseId };
      });

      return newArray;
    }

  }

  createTag(tagForm: NgForm) {
    this.isLoader = true;
    this.data.createdBy = this.globalService.loggedInUser;
    this.data.r4location = "";
    this.data.modifiedBy = this.globalService.loggedInUser;
    if (this.data.locIdFromPP > 0) {
      this.data.locationId = this.data.locIdFromPP;
    } else {
      this.data.locationId = this.locId;
    }
    const modifiedData = {...this.data};
    modifiedData.UseCaseToTags = this.createSelectedUseCaseList(tagForm.value.UseCaseToTags);   

    this.tagMasterService.addTag(modifiedData).subscribe((result: any): void => {
      if (result.value != null && result.value != 0) {
        this.isLoader = false;
        this.data.id = result.value;
        this.globalService.showAlert(AlertComponent, { success: true, message: 'Tag configured successfully.' });
        this.dialogRef.close("added");
        this.isLoader = false;
        this.getAvailableTags();
      }
    },
      error => {
        console.log('error', error);
    });

  }

  convert(str) {
    let date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  updateTag() {
    this.isLoader = true;
    
    this.data.modifiedBy = this.globalService.loggedInUser;
    const modifiedData = {...this.data};
    modifiedData.UseCaseToTags = this.createSelectedUseCaseList(this.data.UseCaseToTags);    
    this.tagMasterService.editTag(modifiedData).subscribe((result: any): void => {
      if (result.value == "Success") {
        this.globalService.showAlert(AlertComponent, { success: true, message: 'Tag updated successfully.' });
        this.dialogRef.close("added");
        this.isLoader = false;       
      }
    });
  }

  getLocationName(locationForTagName) {
    return this.locationList.filter(function (locObj) {
      if (locObj.locationId == locationForTagName) {
        return locObj.locationName;
      }
    });
  }

  updateDilog(rowdata, action): void {
    rowdata.action = action;
    this.checkProperty();
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '80%',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: rowdata,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "Success") {
        this.globalService.showAlert(AlertComponent, { success: true, message: "Updated Successfully" });
      }
    });
  }

  onUseCaseDeSelect(event) {
    this.globalService.showAlert(AlertComponent, { success: false, message: "Cannot remove already subscribed use cases." });
    this.fetchUseCaseToTags();
  }

}
